import styled from 'styled-components';
import { Text, crTheme, Link } from '@comicrelief/component-library';

const Container = styled.div`
  margin: 15px auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media ${crTheme.allBreakpoints('M')} {
    flex-direction: row;
    margin: 40px auto;
  }
  max-width: 850px;
`;

const Column1 = styled.div`
  max-width: 300px;
  @media ${crTheme.allBreakpoints('M')} {
    width: 35%;
  }
`;

const LogoWrapper = styled.div`
  justify-self: start;
  width: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Column2 = styled.div`
  @media ${crTheme.allBreakpoints('M')} {
    width: 80%;
    padding-left: 20px;
    border-left: 1px solid ${crTheme.color('grey_medium')};
  }
`;

export default function FundraisingRegulatorRow() {
  return (
    <Container>
      <Column1>
        <LogoWrapper>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a
            href="https://www.fundraisingregulator.org.uk/validate?registrant=COMIC+RELIEF"
            target="_blank"
            className="fr-digital-badge"
            style={{
              display: 'block', height: 'auto', width: '100%', textDecoration: 'none'
            }}
          >
            <img
              src="https://www.fundraisingregulator.org.uk/fr-badge/80983ed7-ea80-40db-8e52-4a3351d9e77d/en/colour"
              width={240}
              height={70}
              style={{ width: '100%', height: 'auto', display: 'block' }}
              alt="Fundraising Regulator badge with validation link"
              loading="lazy"
            />
          </a>
        </LogoWrapper>
      </Column1>
      <Column2>
        <Text tag="p" family="Montserrat" size="s">
          By working with the best partners like Braintree, GoCardless, Paypal and Stripe, we&apos;ll keep your data safe.
          {' '}
          <Link href="https://www.cafonline.org/" target="blank">Donate using your Charities Aid Foundation account</Link>
          .
          Need help with your donation?
          {' '}
          <Link href="https://www.comicrelief.com/contact-us/" target="blank">Contact us</Link>
          .
        </Text>
      </Column2>
    </Container>
  );
}
